import { render, staticRenderFns } from "./VuetablePaginationBootstrap4.vue?vue&type=template&id=2f086f3a&"
import script from "./VuetablePaginationBootstrap4.vue?vue&type=script&lang=js&"
export * from "./VuetablePaginationBootstrap4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports